// Constants for leave management

export const LEAVE_TYPE_CHOICES = [
  { value: 'Annual', label: 'Annual Leave' },
  { value: 'Sick', label: 'Sick Leave' },
  { value: 'Maternity', label: 'Maternity Leave' },
  { value: 'Paternity', label: 'Paternity Leave' },
  { value: 'Emergency', label: 'Emergency Leave' },
  { value: 'Casual', label: 'Casual Leave' },
  { value: 'Other', label: 'Other' },
];

export const STATUS_CHOICES = [
  { value: 'Pending', label: 'Pending' },
  { value: 'Approved', label: 'Approved' },
  { value: 'Rejected', label: 'Rejected' },
];

export const TABLE_HEAD = [
  { id: 'employee_name', label: 'Employee', alignRight: false },
  { id: 'leave_type', label: 'Leave Type', alignRight: false },
  { id: 'start_date', label: 'Start Date', alignRight: false },
  { id: 'end_date', label: 'End Date', alignRight: false },
  { id: 'days', label: 'Days', alignRight: false },
  { id: 'status', label: 'Status', alignRight: false },
  { id: 'reason', label: 'Reason', alignRight: false },
  { id: 'actions', label: 'Actions', alignRight: false },
];

export const SETTINGS_TABLE_HEAD = [
  { id: 'employee_name', label: 'Employee', alignRight: false },
  { id: 'sick_leaves', label: 'Sick Leaves', alignRight: false },
  { id: 'casual_leaves', label: 'Casual Leaves', alignRight: false },
  { id: 'earned_leaves', label: 'Earned Leaves', alignRight: false },
  { id: 'maternity_leaves', label: 'Maternity Leaves', alignRight: false },
  { id: 'paternity_leaves', label: 'Paternity Leaves', alignRight: false },
  { id: 'unpaid_leaves', label: 'Unpaid Leaves', alignRight: false },
  { id: 'other_leaves', label: 'Other Leaves', alignRight: false },
  { id: 'actions', label: 'Actions', alignRight: false },
];
